<template>
  <div class="configurationList">
    <div class="configurationList_selectionArea">
      <div class="box-wrap">
        <!-- <el-input
          v-model="parameter.job_code"
          placeholder="请输入业务编码"
          style="width: 200px;"
          clearable
        /> -->
        <el-select
          v-model="parameter.job_code"
          placeholder="请选择任务类型"
          filterable
          style=""
        >
          <el-option
            v-for="item in codeList"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          />
        </el-select>
        <el-select
          v-model="parameter.mobile_type"
          placeholder="请选择机型"
          style="width: 200px;"
          clearable
        >
          <el-option
            v-for="item in mobileTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="search"
        >搜索</el-button>
        <el-button
          type="info"
          icon="el-icon-refresh-right"
          @click="reset"
        >重置</el-button>
      </div>
      <div>
        <el-button
          type="success"
          icon="el-icon-plus"
          @click="openCreateDialog"
        >创建</el-button>
      </div>
    </div>
    <div class="configurationList_main">
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >

        <el-table-column
          prop="job_code_text"
          label="业务编码描述"
          align="center"
          min-width="100"
        />
        <el-table-column
          prop="mobile_type_text"
          label="机型"
          align="center"
          min-width="100"
        />
        <el-table-column
          prop="version"
          label="版本"
          align="center"
          min-width="80"
        />
        <el-table-column
          prop="created_at_text"
          label="创建时间"
          align="center"
          min-width="160"
        >
          <template slot-scope="scope">
            {{ scope.row.created_at_text || formatTime(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="updated_at_text"
          label="更新时间"
          align="center"
          min-width="160"
        >
          <template slot-scope="scope">
            {{ scope.row.updated_at_text || formatTime(scope.row.updated_at) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="操作"
          min-width="180"
          align="center"
          fixed="right"
        >
          <template slot-scope="scope">
            <div class="btn-wrap-box">
              <el-button
                type="warning"
                size="mini"
                @click="openUpdateDialog(scope.row)"
              >修改</el-button>
              <el-button
                type="danger"
                size="mini"
                @click="handleDelete(scope.row)"
              >删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <PaginationRight
        :total="tableData.total"
        :page-sizes="[10]"
        :current-page="parameter.page"
        @size-change="fetchPageSizeone"
        @current-change="fetchCurrentPageone"
      />
    </div>

    <!-- 创建/更新弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      width="1200px"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="formRules"
        label-width="100px"
      >
        <el-form-item
          label="机型"
          prop="mobile_type"
        >
          <el-select
            v-model="form.mobile_type"
            placeholder="请选择机型"
            style="width: 100%"
          >
            <el-option
              v-for="item in mobileTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="业务编码"
          prop="job_code"
        >
          <el-select
            v-model="form.job_code"
            placeholder="请选择业务编码"
            style="width: 100%"
            filterable
          >
            <el-option
              v-for="item in codeList"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="脚本内容"
          prop="script_content"
        >
          <script-code-editor
            v-if="dialogVisible"
            v-model="form.script_content"

          />
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="submitForm"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight'
import ScriptCodeEditor from '@/components/ScriptCodeEditor'
import {
  autoScriptIndex,
  autoScriptCreate,
  autoScriptDetail,
  autoScriptUpdate,
  autoScriptDelete
} from '@/api/autoScript'
import { workWechatcodeList } from '@/api/workWechat'
import { filterList } from '@/api/enterprisewechatControl'

export default {
  name: 'AutoScriptManagement',
  components: {
    PaginationRight,
    ScriptCodeEditor
  },
  data() {
    return {
      parameter: {
        page: 1,
        page_size: 10,
        mobile_type: null,
        job_code: null
      },
      tableData: {
        list: [],
        total: 0
      },
      loading: false,
      mobileTypeOptions: [],
      dialogVisible: false,
      dialogTitle: '创建',
      form: {
        id: null,
        mobile_type: null,
        job_code: '',
        script_content: ''
      },
      formRules: {
        mobile_type: [
          { required: true, message: '请选择机型', trigger: 'change' }
        ],
        job_code: [
          { required: true, message: '请输入业务编码', trigger: 'blur' }
        ],
        script_content: [
          { required: true, message: '请输入脚本内容', trigger: 'blur' }
        ]
      },
      submitLoading: false,
      codeList: []
    }
  },
  created() {
    this.getList()
    this.getFilterList()
    this.getCodeList()
  },
  activated() {
    this.getList()
    this.getCodeList()
  },
  methods: {
    async getCodeList() {
      const res = await workWechatcodeList({})
      console.log('res', res)
      this.codeList = res.data || []
    },
    async getList() {
      this.loading = true
      try {
        const res = await autoScriptIndex(this.parameter)
        this.tableData.list = res.data?.list || []
        this.tableData.total = res.data?.total || 0
      } finally {
        this.loading = false
      }
    },
    getFilterList() {
      filterList().then(res => {
        if (res.data && Array.isArray(res.data.mobile_type_list)) {
          this.mobileTypeOptions = res.data.mobile_type_list.map(item => ({
            value: item.value,
            label: item.text
          }))
        }
      })
    },
    search() {
      this.parameter.page = 1
      this.getList()
    },
    reset() {
      this.parameter.page = 1
      this.parameter.mobile_type = null
      this.parameter.job_code = null
      this.getList()
    },
    fetchPageSizeone(e) {
      this.parameter.page_size = e
      this.getList()
    },
    fetchCurrentPageone(e) {
      this.parameter.page = e
      this.getList()
    },
    formatTime(ts) {
      if (!ts) return '--'
      const date = new Date(ts * 1000)
      const Y = date.getFullYear()
      const M = String(date.getMonth() + 1).padStart(2, '0')
      const D = String(date.getDate()).padStart(2, '0')
      const h = String(date.getHours()).padStart(2, '0')
      const m = String(date.getMinutes()).padStart(2, '0')
      const s = String(date.getSeconds()).padStart(2, '0')
      return `${Y}-${M}-${D} ${h}:${m}:${s}`
    },
    openCreateDialog() {
      this.dialogTitle = '创建'
      this.form = {
        id: null,
        mobile_type: null,
        job_code: '',
        script_content: ''
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form?.clearValidate()
      })
    },
    async openUpdateDialog(row) {
      this.dialogTitle = '修改'
      try {
        const res = await autoScriptDetail({ id: row.id })
        const data = res.data || row
        this.form = {
          id: data.id,
          mobile_type: data.mobile_type,
          job_code: data.job_code || '',
          script_content: data.script_content || ''
        }
        this.dialogVisible = true
        this.$nextTick(() => {
          this.$refs.form?.clearValidate()
        })
      } catch (e) {
        this.$message.error('获取详情失败')
      }
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.submitLoading = true
        try {
          if (this.form.id) {
            await autoScriptUpdate(this.form)
            this.$message.success('更新成功')
          } else {
            await autoScriptCreate({
              mobile_type: this.form.mobile_type,
              job_code: this.form.job_code,
              script_content: this.form.script_content
            })
            this.$message.success('创建成功')
          }
          this.dialogVisible = false
          this.getList()
        } catch (e) {
          this.$message.error(e?.message || '操作失败')
        } finally {
          this.submitLoading = false
        }
      })
    },
    handleClose(done) {
      this.dialogVisible = false
      this.form = { id: null, mobile_type: null, job_code: '', script_content: '' }
      this.$nextTick(() => {
        this.$refs.form?.clearValidate()
      })
      done && done()
    },
    async handleDelete(row) {
      try {
        await this.$confirm('是否确定删除该脚本？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          type: 'warning'
        })
        await autoScriptDelete({ id: row.id })
        this.$message.success('删除成功')
        this.getList()
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error('删除失败')
        }
      }
    }
  }
}
</script>

<style scoped>
.configurationList {
  width: 95%;
  margin: 0 auto;
  margin-top: 30px;
}

.configurationList_selectionArea {
  display: flex;
  justify-content: space-between;
}

.configurationList_main {
  margin-top: 20px;
}

.box-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.btn-wrap-box {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  justify-content: center;
}
</style>
